import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * DTO para un item individual en la lista de Órdenes de Transporte.
 * Representa una fila en la tabla de resultados del módulo.
 *
 * @example
 * ```json
 * {
 *   "nroOt": 2169,
 *   "nroLiquidacion": 513,
 *   "tipoEmbarque": "Contenedor",
 *   "cliente": "MONFRUT",
 *   "exportador": "MONFRUT",
 *   "servicio": "SAI-RENGO-SAI",
 *   "nave": "WAN HAI 621",
 *   "etd": "2025-09-19",
 *   "refCliente": "REF-001",
 *   "booking": "C987032077",
 *   "montoNeto": 150000
 * }
 * ```
 */
export class OrdenesTransporteItemDto {
  @ApiProperty({
    description: 'Número de Orden de Transporte (ID único)',
    example: 2169,
  })
  nroOt!: number;

  @ApiPropertyOptional({
    description: 'Número de liquidación asociada',
    example: 513,
  })
  nroLiquidacion?: number;

  @ApiPropertyOptional({
    description: 'Tipo de embarque',
    example: 'Contenedor',
  })
  tipoEmbarque?: string;

  @ApiPropertyOptional({
    description: 'Nombre del cliente',
    example: 'MONFRUT',
  })
  cliente?: string;

  @ApiPropertyOptional({
    description: 'ID del cliente',
    example: 376,
  })
  clienteId?: number;

  @ApiPropertyOptional({
    description: 'Nombre del exportador',
    example: 'MONFRUT',
  })
  exportador?: string;

  @ApiPropertyOptional({
    description: 'ID del exportador',
    example: 376,
  })
  exportadorId?: number;

  @ApiPropertyOptional({
    description: 'Nombre del servicio (calculado: DEPOT-LUGAR-POL)',
    example: 'SAI-RENGO-SAI',
  })
  servicio?: string;

  @ApiPropertyOptional({
    description: 'Nombre de la nave',
    example: 'WAN HAI 621',
  })
  nave?: string;

  @ApiPropertyOptional({
    description: 'Fecha ETD formateada (DD/MM/YYYY)',
    example: '19/09/2025',
  })
  etd?: string;

  @ApiPropertyOptional({
    description: 'Referencia del cliente',
    example: 'REF-001',
  })
  refCliente?: string;

  @ApiPropertyOptional({
    description: 'Número de booking',
    example: 'C987032077',
  })
  booking?: string;

  @ApiPropertyOptional({
    description: 'Monto neto formateado',
    example: '$ 150.000 CLP',
  })
  montoNeto?: string;

  @ApiPropertyOptional({
    description: 'Extra costos formateado',
    example: '$ 25.000 CLP',
  })
  extraCostos?: string;

  @ApiPropertyOptional({
    description: 'Moneda del monto neto',
    example: 'CLP',
  })
  moneda?: string;

  @ApiPropertyOptional({
    description: 'Moneda de los extra costos',
    example: 'USD',
  })
  extraCostosMoneda?: string;

  @ApiPropertyOptional({
    description: 'Subtotal formateado',
    example: '$ 175.000 CLP',
  })
  subTotal?: string;
}
